<template>
  <v-container>
    <v-app-bar app color="white">
      <v-container>
        <v-row>
          <v-app-bar-nav-icon>
            <v-icon @click="goBack">keyboard_arrow_left</v-icon>
          </v-app-bar-nav-icon>
          <v-toolbar-title
            class="ml-4 my-auto font-weight-bold cursor-pointer"
            @click="goBack"
          >
            Go Back
          </v-toolbar-title>
        </v-row>
      </v-container>
    </v-app-bar>
    <survey-choose-template
      v-if="!showTemplates"
      v-on:prebuilt="showTemplates = true"
      v-on:blank="goToBuilder"
    ></survey-choose-template>
    <survey-template-list
      :initialFilter="this.$route.query.filterId"
      v-if="showTemplates"
      v-on:select="selectTemplate"
    ></survey-template-list>
  </v-container>
</template>

<script>
import SurveyChooseTemplate from "@/components/surveys/SurveyChooseTemplate";
import SurveyTemplateList from "@/components/surveys/SurveyTemplateList";
export default {
  name: "CreateSurvey",
  components: {
    "survey-choose-template": SurveyChooseTemplate,
    "survey-template-list": SurveyTemplateList
  },
  data: () => ({
    showTemplates: false
  }),
  created() {
    this.$store.dispatch("survey/resetSurvey");
    this.$store.dispatch("company/getCoreValues");
    if (this.$route.query.filterId) {
      this.showTemplates = true;
    }
  },
  methods: {
    goBack() {
      if (this.showTemplates) {
        this.showTemplates = false;
      } else {
        this.$router.push({ path: "/features/surveys" });
      }
    },
    goToBuilder() {
      this.$router.push({ path: "/features/surveys/add/builder" });
    },
    selectTemplate(templateId) {
      this.$router.push({
        path: "/features/surveys/add/builder?templateId=" + templateId
      });
    }
  }
};
</script>
